import { Email, Telephone } from '@ori-ui/icons';
import { Link } from '@ori-ui/mui';
import type { FC } from 'react';

import { Root } from './styles';

export interface ContactProps {
  contact: string | null | undefined;
  type: 'email' | 'phone';
}

export const Contact: FC<ContactProps> = ({ contact, type }) => {
  if (!contact) {
    return null;
  }

  return (
    <Root>
      {type === 'email' ? <Email /> : <Telephone />}
      <Link
        variant="body1"
        href={`${type === 'email' ? 'mailto' : 'tel'}:${contact}`}
      >
        {contact}
      </Link>
    </Root>
  );
};
